<template>
    <div>
    	<div>
	        <Row class="expand-row">
	        	<Table :no-data-text="$t('common.noData')" :columns="columns" :data="portListData" style="width: 100%;"></Table>
	        </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        },
        data () {
            return {
                columns: [
                  {
                    title: this.$t("RAM.AWS.ECR.imageTag"),
                    key: "imageTag"
                  },
                  {
                    title: this.$t("RAM.AWS.ECR.componentType"),
                    key: "buildType"
                  },
                  {
                    title: this.$t("RAM.AWS.ECR.pushPosition"),
                    key: "imagePushAt"
                  },
                  {
                    title: this.$t("RAM.AWS.ECR.size"),
                    key: "imageSizeInBytes"
                  },
                  // {
                  //   title: this.$t("RAM.AWS.ECR.imageURI"),
                  //   key: "direction"
                  // },
                  {
                    title: this.$t("RAM.AWS.ECR.digest"),
                    key: "imageDigest"
                  },
                  {
                    title: this.$t("RAM.AWS.ECR.scanningState"),
                    key: "imageScanStatusName"
                  },
                  {
                    title: this.$t("RAM.AWS.ECR.bug"),
                    key: "imageScanFindingsSummary"
                  }
                ],
                portListData:this.row.ecrImageDTOList
            }
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	width: 145px;
    	display: block;
    	float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ecr/TableExpand.vue